import {
    GET_STATE_SUCCESS,
    GET_STATE_FAIL,
    GET_OCCUPATION_SUCCESS,
    GET_OCCUPATION_FAIL,
    GET_RELATEDPERSONTYPE_SUCCESS,
    GET_RELATEDPERSONTYPE_FAIL,
    GET_EDUCATION_SUCCESS,
    GET_EDUCATION_FAIL,
    GET_OCCUPATIONDETAILS,
    GET_OCCUPATIONDETAILS_SUCCESS,
    GET_OCCUPATIONDETAILS_FAIL,
    GET_ASSETDETAILS_SUCCESS,
    GET_ASSETDETAILS_FAIL,
    GET_OTHERBANKACCOUNTS,
    GET_OTHERBANKACCOUNTS_SUCCESS,
    GET_OTHERBANKACCOUNTS_FAIL,
    GET_ACCOUNTTYPE_SUCCESS,
    GET_ACCOUNTTYPE_FAIL,
    GET_ENTITYTYPE_SUCCESS,
    GET_ENTITYTYPE_FAIL,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_FAIL,
    GET_BRANCH_SUCCESS,
    GET_BRANCH_FAIL,
    GET_POI_SUCCESS,
    GET_POI_FAIL,
    GET_REASON_TO_BECOME_CUSTOMER_SUCCESS,
    GET_REASON_TO_BECOME_CUSTOMER_FAIL
} from "./actionTypes";

const INIT_STATE = {
    stateData: [],
    occupationData: [],
    relatedPersonTypeData: [],
    educationData: [],
    occupationDetailsData: [],
    assetDetailsData: [],
    otherBankAccountsData: [],
    accountTypeData: [],
    entityTypeData: [],
    locationData: [],
    branchData: [],
    poiData: [],
    reasonToBecomeCustomer: []
};

const Registration = (state = INIT_STATE, action) => {
   
    switch (action.type) {
        //GetAll State
        case GET_STATE_SUCCESS:
            return {
                ...state,
                stateData: action.payload,
            };

        case GET_STATE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        // GetALl Occupation
        case GET_OCCUPATION_SUCCESS:
            return {
                ...state,
                occupationData: action.payload,
            };
        case GET_OCCUPATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll Related Person Type 
        case GET_RELATEDPERSONTYPE_SUCCESS:
            return {
                ...state,
                relatedPersonTypeData: action.payload,
            };
        case GET_RELATEDPERSONTYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll Education
        case GET_EDUCATION_SUCCESS:
            return {
                ...state,
                educationData: action.payload,
            };
        case GET_EDUCATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll OccupationDetails
        case GET_OCCUPATIONDETAILS_SUCCESS:
            return {
                ...state,
                occupationDetailsData: action.payload,
            };
        case GET_OCCUPATIONDETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll AssetDetails
        case GET_ASSETDETAILS_SUCCESS:
            return {
                ...state,
                assetDetailsData: action.payload,
            };
        case GET_ASSETDETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll OtherBankAccounts
        case GET_OTHERBANKACCOUNTS_SUCCESS:
            return {
                ...state,
                otherBankAccountsData: action.payload,
            };
        case GET_OTHERBANKACCOUNTS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll AccountType
        case GET_ACCOUNTTYPE_SUCCESS:
            return {
                ...state,
                accountTypeData: action.payload,
            };
        case GET_ACCOUNTTYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll EntityType
        case GET_ENTITYTYPE_SUCCESS:
            return {
                ...state,
                entityTypeData: action.payload,
            };
        case GET_ENTITYTYPE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll Location
        case GET_LOCATION_SUCCESS:
            return {
                ...state,
                locationData: action.payload,
            };
        case GET_LOCATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        // GetByLocationId Branch
        case GET_BRANCH_SUCCESS:
            return {
                ...state,
                branchData: action.payload,
            };
        case GET_BRANCH_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        //GetAll Poi
        case GET_POI_SUCCESS:
            return {
                ...state,
                poiData: action.payload,
            };
        case GET_POI_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        // GetAll Reason To Become Customer
        case GET_REASON_TO_BECOME_CUSTOMER_SUCCESS:
            return {
                ...state,
                reasonToBecomeCustomer: action.payload,
            };
        case GET_REASON_TO_BECOME_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload,
            };    

        default:
            return state;
    }
};

export default Registration;